<template>
  <v-snackbar
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    :top="snackbar.top"
    v-model="snackbar.active"
  >

    <span v-if="snackbar.key">{{ $t(`texts.${snackbar.key}`) }}</span>
    <span v-if="snackbar.text" v-html="snackbar.text" style="display:block"></span>
    <template v-slot:action>
      <v-btn
        icon
        text
        class="white--text"
        @click="hideMessage()"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapMessagesState, mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  computed: {
    ...mapMessagesState([
      'snackbar',
    ]),
  },
  methods: {
    ...mapMessageActions([
      'hideMessage',
    ]),
  },
};
</script>
